import { createContext, useContext } from "react";

/**
 * Открыт ли поверх страницы какой-либо RouteDialog (видео/канал/стрим/...).
 * Значение выставляется в AppRoutes по наличию location.state.background:
 * внутри <Routes location={background}> useLocation() возвращает фоновую
 * локацию, поэтому компоненты страницы сами этого узнать не могут.
 */
const RouteDialogOpenContext = createContext(false);

export function useIsRouteDialogOpen() {
  return useContext(RouteDialogOpenContext);
}

export default RouteDialogOpenContext;
